// extracted by mini-css-extract-plugin
export var breakpointsButton = "PatternIframe-module--breakpoints-button--iS6uE";
export var bxTextTruncateEnd = "PatternIframe-module--bx--text-truncate--end--zphOW";
export var bxTextTruncateFront = "PatternIframe-module--bx--text-truncate--front--y+Ibg";